import React from 'react';

function NumpadInputButtons({ option, handleClick, isDisabled }) {
  return (
    <button
      className={`numpad-modifier ${option} ${isDisabled ? 'disabled' : ''}`}
      onClick={handleClick}
    >
      <i className={`icon-${option === 'left' ? `minus` : `plus`}`} />
    </button>
  );
}
export default NumpadInputButtons;
